import React from "react";

const Button = (props)=>{
    return(
        <button 
            style={props.styles} 
            type="button" 
            className={"btn "+props.class} 
            title={props.title}
            onClick={(e) => props.action(e, props.params)}
            disabled={props.disabled}
        >
            {props.text}
        </button>
    )
}

export default Button;

Button.defaultProps = {
    style:{},
    class:'',
    action:()=>{},
    params:{},
    title:'',
    disabled:false
}